import React from "react";
import { Tooltip } from "@mui/material";
const ToggleDensityMode = ({ event, children }) => {
  return (
    <Tooltip
      placement="top"
      title="Density Mode"
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -5],
            },
          },
        ],
      }}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "black",
            color: "white",
            boxShadow: "none",
            height: "23px",
            display: "flex",
            alignItems: "center",
          },
        },
      }}
    >
      <button type="button" onClick={event} className="tooltip">
        {children}

        {/* <span className={`tooltiptext text-[10px] w-[85px] bottom-full left-1/2 ml-[-40px]`}>Density Mode</span> */}
      </button>
    </Tooltip>
  );
};

export default ToggleDensityMode;
